import type { TabsProps } from 'antd';
import type { TTransportPerformanceGroups } from 'shared/stores/helpers/transport-performance-groups-helper';
import { ALL_TAB_KEY } from 'shared/stores/use-transport-performance-groups';

export const buildGroupTabItems = (groups: TTransportPerformanceGroups, allLabel: string): TabsProps['items'] => [
  { key: ALL_TAB_KEY, label: allLabel, closable: false },
  ...Object.keys(groups).map((name) => ({ key: name, label: name, closable: true })),
];
